import { create } from 'zustand';

/**
 * PRX-85: the patient the current page or dialog is about — read by the top
 * bar so it can show a bold name on the recent-patients trigger. Transient on
 * purpose: this is "what am I looking at right now," not history, so it is
 * NOT persisted — a stale localStorage patient surviving a refresh or
 * navigation would be a correctness bug, not a convenience.
 */
export interface CurrentPatient {
  compositeId: string;
  pharmacyId: string;
  /** "Last, First" — matches the billing/NEXI/queue convention. */
  displayName: string;
}

interface CurrentPatientState {
  patient: CurrentPatient | null;
  setPatient: (patient: CurrentPatient | null) => void;
}

export const useCurrentPatientStore = create<CurrentPatientState>()((set) => ({
  patient: null,
  setPatient: (patient) => set({ patient }),
}));
